import React from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withStyles, Grid } from '@material-ui/core'
import get from 'lodash.get'
import { bindActionCreators } from 'redux'

import PropertyCard from './PropertyCard'
import Loader from './Loader'
import { getSimilarPropertiesQuery, fetchWithTimeout } from '../utils'
import * as actions from '../actions'

const styles = theme => ({
  similarProps: {
    padding: '35px 32px 23px',
    [theme.breakpoints.down('sm')]: {
      padding: '35px 32px 70px',
    },
    [theme.breakpoints.down('xs')]: {
      padding: '22px 15px 15px',
    },
    '& h5': {
      fontSize: '29px',
      fontWeight: '300',
      color: '#231f20',
      margin: '0 0 23px',
      [theme.breakpoints.down('xs')]: {
        margin: '0 0 16px',
        fontSize: '20px',
      },
    },
  },
  propertySmallCard: {
    margin: '10px',
  },
  gridLink: {
    outline: 'none',
    display: 'block',
    margin: '0',
    fontSize: 0,
    boxShadow: '0px 7px 23px 0px rgba(0, 0, 0, 0.04)',
    '&:hover': {
      boxShadow: '0 7px 23px rgba(0,0,0,0.14), 0 10px 10px rgba(0,0,0,0.04)',
    },
  },
})

class SimilarProperties extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      similarProperties: [],
    }
  }

  componentDidMount() {
    const propertyId = this.props.propertyId
    propertyId && this.fetchSimilarProperties(propertyId)
  }

  componentDidUpdate(prevProps) {
    let propertyId = this.props.propertyId
    if (propertyId && propertyId !== prevProps.propertyId) {
      this.fetchSimilarProperties(propertyId)
    }
  }

  fetchSimilarProperties = pId => {
    this.setState({ loading: true }, () => {
      const { user } = this.props
      const token = user && user.token ? user.token : null
      let headers = {
        'Content-Type': 'application/json; charset=utf-8',
      }
      token && (headers.Authorization = `Bearer ${token}`)
      fetchWithTimeout(
        `${process.env.REACT_APP_API_URL}`,
        {
          method: 'post',
          headers,
          body: JSON.stringify(getSimilarPropertiesQuery(pId)),
        },
        5000
      )
        .then(response => {
          const sProperties = get(response, 'data.similarProperties', [])
          this.setState({
            similarProperties: sProperties,
          })
          this.stopLoading()
          this.props.actions.updateSimilarProperties(sProperties)
        })
        .catch(err => {
          // handle errors and timeout error
          this.setState({
            similarProperties: [],
          })
          this.stopLoading()
          // logger.error('Error while fetching similar properties -->', err)
        })
    })
  }

  scrollToTop = evt => {
    document.getElementById('property_detail').scrollTop = 0
  }

  stopLoading = () => {
    this.setState({ loading: false })
  }

  render() {
    const { classes, queryAddress = '', noMap } = this.props
    const { similarProperties: properties, loading } = this.state
    return (
      <Grid item xs={12}>
        <Grid container className={classes.similarProps}>
          <Grid item xs={12}>
            <h5>Similar Properties</h5>
          </Grid>
          <Grid item xs={12} style={{ margin: '-10px' }}>
            <Grid container>
              {loading ? (
                <Loader />
              ) : properties.length ? (
                properties.map((p, ix) => (
                  <Grid item key={`card_${ix}`} value={p} className={`grid-card small-grid-card ${classes.propertySmallCard}`}>
                    <Link
                      to={`${p.id}${
                        noMap || !queryAddress
                          ? ''
                          : typeof this.props.searchStringForSimilarProp !== 'undefined'
                          ? `?${this.props.searchStringForSimilarProp}`
                          : ''
                      }`}
                      className={classes.gridLink}
                      onClick={this.scrollToTop}>
                      <PropertyCard key={`prop_${ix}`} property={p} noMap cardPlacement />
                    </Link>
                  </Grid>
                ))
              ) : (
                <p style={{ margin: '10px' }}>No Similar Properties Found</p>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    )
  }
}

SimilarProperties.propTypes = {
  classes: PropTypes.object.isRequired,
}

function mapStateToProps(state) {
  return {
    user: state.user,
    queryAddress: state.properties.get('queryAddress'),
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
  }
}

const similarProperties = connect(
  mapStateToProps,
  mapDispatchToProps
)(SimilarProperties)

export default withStyles(styles)(similarProperties)



// WEBPACK FOOTER //
// ./src/components/SimilarProperties.js